import React from 'react'
import ProtectedRoute from '../middleware/ProtectedRoute'
import { readLocalStorageValue } from '@mantine/hooks'
import { AppShell, Box, ScrollArea, rem, Title} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import Breadcrumb from '../component/ui/Breadcrumb'
import ImgPatternBody from '../assets/img/page/pattern.svg' 
import LayoutHeader from '../component/ui/Layout/LayoutHeader'
import LayoutSidebar from '../component/ui/Layout/LayoutSidebar'
import { useViewportSize } from '@mantine/hooks'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const AuthLayout = ({ children }) => {
  const { isLoadingUser, data } = useSelector(state => state.user_login)
  const { pathname } = useLocation()
  const layoutValue = readLocalStorageValue({ key: 'manage-app-layout' })
  const themeValue = readLocalStorageValue({ key: 'manage-app-theme' })
  const [openSidebarDesktop, { toggle: toggleDesktop }] = useDisclosure(true)
  const [openSidebarMobile, { toggle: toggleMobile }] = useDisclosure(false)
  const { width } = useViewportSize()

  const initGreeting = (pathname) => {
    if (pathname === '/dashboard') {
      return (
        <Box py={60} ta='center'>
          <Title order={1} c='white' fw={600}>Good day, {!isLoadingUser ? data.attributes.name : ''}</Title>
          <Title order={2} c='white' fw={500}>Welcome to our's company dashboard page. Have fun working.</Title>
        </Box>
      )
    }
  }

  const initializeBreadcrumb = (pathname) => {
    if (pathname !== '/dashboard') {
      return (
        <Box mb={14} ml={2}>
          <Breadcrumb />
        </Box>
      )
    }
  }

  const handleLayout = (layout) => {
    if (layout === 'nav-sidebar') {
      return (
        <AppShell
          transitionDuration={700}
          transitionTimingFunction="ease"
          offsetScrollbars={false}
          header={{ height: 80 }}
          navbar={{
            width: 280,
            breakpoint: 'sm',
            collapsed: { mobile: !openSidebarMobile, desktop: !openSidebarDesktop }
          }}
          padding='md'
          disabled={layoutValue !== 'nav-sidebar'}
        >
          <AppShell.Header>
            <LayoutHeader mobileToggle={toggleMobile} desktopToggle={toggleDesktop} />
          </AppShell.Header>
          <AppShell.Navbar>
            <AppShell.Section grow component={ScrollArea}>
              <LayoutSidebar />
            </AppShell.Section>
          </AppShell.Navbar>
          <AppShell.Main style={{ position: 'relative', backgroundColor: themeValue !== 'dark' ? '#f7f0f0' : '#2e2e2e', zIndex: 1 }}>
            <Box style={{ position: 'absolute', backgroundImage: `url(${ImgPatternBody})`, left: 0, right: 0, top: 0, bottom: '27rem', height: '27rem', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', zIndex: -1 }} />
            {initGreeting(pathname)}
            <Box p={20} mx={14} mt={20} style={{ backgroundColor: themeValue !== 'dark' ? '#ffffff' : '#242424', borderRadius: '12px'}}>
              {initializeBreadcrumb(pathname)}
              { children }
            </Box>
          </AppShell.Main>
        </AppShell>
      )
    } else if (layout === 'nav-header') {
      return (
        <AppShell 
          header={{ height: width < 850 ? 80 : 140 }}
          offsetScrollbars={false}
          navbar={{
            width: 280,
            breakpoint: 'sm',
            collapsed: { mobile: !openSidebarMobile, desktop: true }
          }}
          padding="md"
        >
          <AppShell.Header>
            <LayoutHeader />
          </AppShell.Header>
          <AppShell.Navbar>
            <AppShell.Section grow component={ScrollArea}>
              <LayoutSidebar />
            </AppShell.Section>
          </AppShell.Navbar>
          <AppShell.Main pt={`calc(${rem(width < 850 ? 70 : 130)} + var(--mantine-spacing-md))`}  style={{ position: 'relative', backgroundColor: themeValue !== 'dark' ? '#f7f0f0' : '#2e2e2e', zIndex: 1 }}>
            <Box style={{ position: 'absolute', backgroundImage: `url(${ImgPatternBody})`, left: 0, right: 0, top: 0, bottom: '27rem', height: '27rem', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', zIndex: -1 }} />
            {initGreeting(pathname)}
            <Box p={20} mx={14} mt={20} style={{ backgroundColor: themeValue !== 'dark' ? '#ffffff' : '#242424', borderRadius: '12px' }}>
              {initializeBreadcrumb(pathname)}
              { children }
            </Box>
          </AppShell.Main>
        </AppShell>
      )
    }
  }
  return (
    <ProtectedRoute>
      {handleLayout(layoutValue)}
    </ProtectedRoute>
  )
}

export default AuthLayout